import {
  AuthLoginState,
  authLoginInitialState,
  authLoginReducer,
} from './login.reducer';
import {
  AuthSignUpState,
  authSignUpInitialState,
  authSignUpReducer,
} from './sign-up.reducer';
import { authUserReducer } from './user.reducer';
import { User } from '@digitaix/types';

export interface AuthState {
  user: User | null | false;
  login: AuthLoginState;
  signUp: AuthSignUpState;
}

export const authInitialState: AuthState = {
  user: null,
  login: authLoginInitialState,
  signUp: authSignUpInitialState,
};

export function authReducer(state = authInitialState, action: any) {
  const user = authUserReducer(state.user, action);
  if (state.user !== user) {
    state = { ...state, user };
  }

  const login = authLoginReducer(state.login, action);
  if (state.login !== login) {
    state = { ...state, login };
  }

  const signUp = authSignUpReducer(state.signUp, action);
  if (state.signUp !== signUp) {
    state = { ...state, signUp };
  }

  return state;
}
